import axios from 'axios'

let hostname = '/raw_data/api'

// if (process.env.NODE_ENV === 'development') {
// hostname = 'http://localhost:3000/raw_data/api'
// } else {
// hostname = 'https://data-tagging-dev.insightera.co.th/raw_data/api'
// }

let instance = () => {
  let user = JSON.parse(localStorage.getItem('raw_data'))
  let axiosInstance = axios.create({
    baseURL: hostname,
    timeout: 0,
    headers: {
      'content-type': 'application/json',
      // 'user-id': user ? user.userId : undefined,
      Authorization: `Token ${user ? user.token : undefined}`
    }
  })

  axiosInstance.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      console.log(error)
      if (error.response.status === 401) {
        localStorage.removeItem('raw_data')
        if (
          !window.location.hash.startsWith('#/login') &&
          !window.location.hash.startsWith('#/tests')
        ) {
          window.location.reload()
        }
      }
      return Promise.reject(error)
    }
  )

  return axiosInstance
}

const getData = async (id) => {
  const result = await instance()('/record-chunk/' + id)
  return result.data
}

const getChunkData = async (data) => {
  // {configId, username, password, start, end}
  let result = {}
  try {
    result.data = await instance()('/record-chunk', {
      method: 'POST',
      data: data
    })
  } catch (e) {
    result.error = e.response.data.message
  }
  return result
}

const updateChunkData = async (chunkId, data) => {
  let result = null
  try {
    result = await instance()('/record-chunk/' + chunkId, {
      method: 'PUT',
      data: data
    })
    result = result.data.data
  } catch (error) {
    result = {
      error: error.response.data
    }
  }
  return result
}

const duplicateRecord = async (chunkId, _id) => {
  const result = await instance()('/record-chunk/' + chunkId + '/duplicate', {
    method: 'POST',
    data: { _id }
  })
  return result.data
}

const deleteRecord = async (chunkId, _id) => {
  const result = await instance()('/record-chunk/' + chunkId + '/delete', {
    method: 'DELETE',
    data: { _id }
  })
  return result.data
}

const updateRecords = async (chunkId, records) => {
  const result = await instance()('/record-chunk/' + chunkId + '/records', {
    method: 'PUT',
    data: { records: records }
  })
  return result.data
}

const saveRecords = async (chunkId, records) => {
  const result = await instance()('/record-chunk/' + chunkId + '/records', {
    method: 'POST',
    data: {
      chunkId: chunkId,
      records: records
    }
  })
  return result.data
}

const exportExcel = async (data) => {
  const result = await instance()('/record-chunk/' + data.chunkId + '/export', {
    method: 'POST',
    data: data
  })
  return result.data
}

const auth = async ({ username, password }) => {
  return instance()('/login', {
    method: 'POST',
    data: { username, password }
  })
}

const getAccounts = async () => {
  const result = await instance()('/table-config')
  return result.data
}

const getUsers = async () => {
  const result = await instance()('/users')
  return result.data
}

const getUserByID = async (id) => {
  const result = await instance()(`/users/${id}`)
  return result.data
}

const createUser = async (data) => {
  let result = {}
  try {
    result = await instance()(`/users`, {
      method: 'POST',
      data: data
    })
  } catch (error) {
    result = {
      data: { data: null }
    }
  }
  return result.data
}

const updateUserProfile = async (_id, data) => {
  const result = await instance()(`/users/${_id}/profile`, {
    method: 'PUT',
    data,
    headers: {
      'content-type': 'application/multipart'
    }
  })
  return result.data
}

const updateUserAccountSetting = async (_id, data) => {
  const result = await instance()(`/users/${_id}/account-setting`, {
    method: 'PUT',
    data
  })
  return result.data
}

const changePassword = async (data) => {
  const result = await instance()(`/me/change-password`, {
    method: 'PUT',
    data
  })
  return result.data
}

const updateMe = async (data) => {
  const result = await instance()(`/me`, {
    method: 'PUT',
    data
  })
  return result.data
}

const deleteUser = async (_id) => {
  const result = await instance()(`/users/${_id}`, {
    method: 'DELETE'
  })
  return result.data
}

const getExportHistory = async (data) => {
  let configId = data.configId
  delete data.configId
  let params = data
  const result = await instance()(`/table-config/${configId}/history`, {
    params: params
  })
  return result.data
}

const getUnpaidPaymentMembers = async () => {
  const result = await instance()(`/payment/members`, {
    method: 'GET'
  })
  return result.data
}

const getPaymentDetailByUsername = async (username, paymentStatus) => {
  const result = await instance()(`/payment/${username}/detail`, {
    method: 'GET',
    params: { paymentStatus }
  })
  return result.data
}

const updatePaymentDetail = async (chunkIds, data) => {
  const result = await instance()(`/payment`, {
    method: 'PUT',
    data: {
      ...data,
      chunkIds
    }
  })
  return result.data
}

const getAccountConfig = async (configId) => {
  const result = await instance()('/table-config/' + configId)
  return result.data
}

const getUndeletedPages = async () => {
  return instance()('/pages')
}
const deleteUndeletedPage = async (id) => {
  return instance()('/pages/' + id, {
    method: 'DELETE'
  })
}
const createUndeletedPage = async (data) => {
  return instance()('/pages', {
    method: 'POST',
    data
  })
}

const getAllSensitiveAreaKeyword = () => {
  return instance()('/sensitive-area-keywords', {
    method: 'GET'
  })
}
const getSensitiveAreaKeywordById = (id) => {
  return instance()('/sensitive-area-keywords/' + id, {
    method: 'GET'
  })
}
const updateSensitiveAreaKeyword = (id, data) => {
  return instance()('/sensitive-area-keywords/' + id, {
    method: 'PUT',
    data
  })
}
const deleteSensitiveAreaKeyword = (id) => {
  return instance()('/sensitive-area-keywords/' + id, {
    method: 'DELETE'
  })
}
const createSensitiveAreaKeyword = (data) => {
  return instance()('/sensitive-area-keywords', {
    method: 'POST',
    data
  })
}

const matchingSensitiveAreaByChunkId = (id, data) => {
  return instance()(`/record-chunk/${id}/sensitive-area-redo`, {
    method: 'PUT',
    data
  })
}

const keywordChecker = (data) => {
  return instance()(`/internal/keyword-checker`, {
    method: 'POST',
    data
  })
}

const register = (data) => {
  return instance()(`/register`, {
    method: 'POST',
    data,
    headers: {
      'content-type': 'application/multipart'
    }
  })
}

const getRegisterConsent = (data) => {
  return instance()(`/register-consent`, {
    method: 'GET',
    data
  })
}

const getDocumentByUserId = ({ userId, documentType }) => {
  return instance()(`/document/${userId}/download/${documentType}`, {
    method: 'GET',
    responseType: 'arraybuffer'
  })
}

const myDocument = (documentType) => {
  return instance()(`me/document/download/${documentType}`, {
    method: 'GET',
    responseType: 'arraybuffer'
  })
}

const searchRecordChunkByDate = (start, end) => {
  return instance()(`/record-chunk/search-by-date`, {
    method: 'GET',
    params: { start, end }
  })
}

const getDOMCategoryByAccount = (account) => {
  return instance()(`/export/get-dom-category-by-account`, {
    method: 'GET',
    params: { account }
  })
}

const splitCategoryByDate = (data) => {
  return instance()(`/export/split-category-by-date`, {
    method: 'POST',
    data
  })
}

const getAllTestData = async (filter) => {
  const response = await instance()('/test/answer-record-chunk', {
    method: 'POST',
    data: filter
  })
  return response.data.data
}

const getTestData = async (id) => {
  const response = await instance()('/test/answer-record-chunk/' + id, {
    method: 'GET'
  })
  return response.data
}

const validateTestData = async (id) => {
  const response = await instance()(
    '/test/answer-record-chunk/' + id + '/validate',
    {
      method: 'GET'
    }
  )
  return response.data
}

const updateTestChunkData = async (chunkId, data) => {
  let result = null
  try {
    result = await instance()('/test/answer-record-chunk/' + chunkId, {
      method: 'PUT',
      data: data
    })
    result = result.data.data
  } catch (error) {
    result = {
      error: error.response.data
    }
  }
  return result
}

const duplicateTestRecord = async (chunkId, _id) => {
  const result = await instance()(
    'test/answer-record-chunk/' + chunkId + '/duplicate',
    {
      method: 'POST',
      data: { _id }
    }
  )
  return result.data
}

const deleteTestRecordChunk = async (chunkId) => {
  const result = await instance()('test/answer-record-chunk/' + chunkId, {
    method: 'DELETE'
  })
  return result.data
}

const updateTestRecords = async (chunkId, records) => {
  const result = await instance()(
    'test/answer-record-chunk/' + chunkId + '/records',
    {
      method: 'PUT',
      data: { records: records }
    }
  )
  return result.data
}

const saveTestRecords = async (chunkId, records) => {
  const result = await instance()(
    '/test/answer-record-chunk/' + chunkId + '/records',
    {
      method: 'POST',
      data: {
        chunkId: chunkId,
        records: records
      }
    }
  )
  return result.data
}

const createTest = async (fullname) => {
  const result = await instance()('/test/answer-record-chunk/create', {
    method: 'POST',
    data: {
      fullname
    }
  })
  return result.data
}

const convertCateory = async (chunkId) => {
  const result = await instance()(`/record-chunk/${chunkId}/convert-category`, {
    method: 'POST'
  })
  return result.data
}

const uploadClientEdit = async (file, date, isOldFormat) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('date', date)
  const res = await instance()
    .post(`/accuracy_analytic/clientEdit`, formData, {
      params: {
        oldFileFormat: isOldFormat
      }
    })
    .catch((e) => {
      throw e
    })
  return res.data
}

const uploadInternalEdit = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  const res = await instance()
    .post(`/accuracy_analytic/internalEdit`, formData)
    .catch((e) => {
      throw e
    })
  return res.data
}

const getAnalyticSummary = async (date) => {
  // date = YYYY-MM
  const res = await instance()
    .get(`/accuracy_analytic/summary`, { params: { date: date } })
    .catch((e) => {
      throw e
    })
  return res.data
}

const getAnalyticFiles = async () => {
  const res = await instance()
    .get(`/accuracy_analytic/statusExcel`)
    .catch((e) => {
      throw e
    })
  return res.data
}

const splitRecordChunk = async (recordChunkId, perFile, splitType) => {
  const res = await instance()
    .post(`/record-chunk/${recordChunkId}/split`, {
      perFile,
      splitType
    })
    .catch((e) => {
      throw e
    })
  return res.data
}
const splitRecordChunkByCategory = async (recordChunkId, splitBrands) => {
  const res = await instance()
    .post(`/record-chunk/${recordChunkId}/split-category`, {
      splitBrands
    })
    .catch((e) => {
      throw e
    })
  return res.data
}

const downloadExportFile = async (exportQueueId) => {
  return instance()
    .request({
      url: `/record-chunk/${exportQueueId}/export/download`, // Server URL
      method: 'GET',
      responseType: 'blob' // Important to handle the binary data
    })
    .then((response) => {
      const disposition = response.headers['content-disposition']
      const fileName = disposition
        ? disposition.split('filename=')[1].replace(/"/g, '')
        : 'downloaded_file'

      const file = new Blob([response.data], { type: 'application/zip' })

      const downloadUrl = URL.createObjectURL(file)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
}

const clearVisibleExportQueue = async (ids) => {
  const res = instance()
    .request({
      url: `/export/clear-visible`, // Server URL
      method: 'PUT',
      data: { ids }
    })
    .catch((e) => {
      throw e
    })
  return res.data
}

const getTeamPerformance = async (startDate, endDate) => {
  const res = await instance()
    .get(`/summary/team-performance`, {
      params: { startDate, endDate }
    })
    .catch((e) => {
      throw e
    })
  return res.data
}

const getOverviewStatus = async (startDate, endDate) => {
  const res = await instance()
    .get(`/summary/overview-status`, {
      params: { startDate, endDate }
    })
    .catch((e) => {
      throw e
    })
  return res.data
}

export default {
  getAnalyticFiles,
  convertCategory: convertCateory,
  createTest,
  validateTestData,
  getAllTestData,
  getTestData,
  updateTestChunkData,
  duplicateTestRecord,
  deleteTestRecordChunk,
  updateTestRecords,
  saveTestRecords,

  splitCategoryByDate,
  getDOMCategoryByAccount,
  searchRecordChunkByDate,
  getDocumentByUserId,
  myDocument,
  getRegisterConsent,
  register,
  auth,
  getData,
  getChunkData,
  updateChunkData,
  duplicateRecord,
  updateRecords,
  saveRecords,
  exportExcel,
  getAccounts,
  deleteRecord,
  getUsers,
  getExportHistory,
  createUser,
  updateUserProfile,
  updateUserAccountSetting,
  deleteUser,
  getUnpaidPaymentMembers,
  getPaymentDetailByUsername,
  updatePaymentDetail,
  getAccountConfig,
  getUndeletedPages,
  deleteUndeletedPage,
  createUndeletedPage,
  getUserByID,

  createSensitiveAreaKeyword,
  getAllSensitiveAreaKeyword,
  getSensitiveAreaKeywordById,
  updateSensitiveAreaKeyword,
  deleteSensitiveAreaKeyword,
  matchingSensitiveAreaByChunkId,
  keywordChecker,
  updateMe,
  changePassword,
  uploadClientEdit,
  uploadInternalEdit,
  getAnalyticSummary,
  splitRecordChunk,

  downloadExportFile,
  splitRecordChunkByCategory,
  clearVisibleExportQueue,
  getTeamPerformance,
  getOverviewStatus
}
